import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Select } from 'antd';
import { dimensionsListSelector } from '@store/common/dimensionList/selectors';
import { setDimension } from '@store/overviewDashboard/dimensionData/actions';
import { kpiMetricSelector } from '@store/overviewDashboard/base/selectors';
import BenchmarkIconConditional from './BenchmarkIconConditional';
import DimensionBetaLabel from '@src/components/dimension-panel-hz/dimensionSelectorPopup/DimensionBetaLabel';

const { Option } = Select;

function DimensionDropdown({ dimension, widgetIndex, dimensionIndex }) {
  const dispatch = useDispatch();
  const selectedKpiMetric = useSelector(kpiMetricSelector);
  // update dimension
  const onChange = (value) => {
    dispatch(setDimension(widgetIndex, dimensionIndex, value));
  };
  const { dimensionsList } = useSelector(
    createSelector(dimensionsListSelector, (dimensionList) => {
      const options: any[] = [];

      dimensionList.forEach((d) => {
        // build dropdown options
        // Removing CDN as it it not supported by backednd for SPI
        if (d.groupBy !== 'CDN') {
          options.push({
            value: d.groupBy,
            label: d.name,
            icon: (
              <BenchmarkIconConditional
                dimension={d.groupBy}
                selectedKpiMetric={selectedKpiMetric}
              ></BenchmarkIconConditional>
            ),
          });
        }
      });
      options.sort((a, b) => a.label.localeCompare(b.label));
      return { dimensionsList: options };
    }),
  );
  return (
    <Select
      showSearch
      filterOption={(input, option) =>
        String(option?.title ?? '')
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      // options={dimensionsList}
      value={dimension}
      onChange={onChange}
      variant="borderless"
      styles={{ popup: { root: { minWidth: 280 } } }}
      style={{ width: 'fit-content', maxWidth: 380, minWidth: 100 }}
      size="large"
      optionLabelProp="label"
    >
      {dimensionsList.map((dimension, i) => (
        <Option
          key={i}
          value={dimension.value}
          title={dimension.label}
          label={<DimensionBetaLabel name={dimension.label} groupBy={dimension.value} />}
        >
          {dimension.icon}
          <DimensionBetaLabel name={dimension.label} groupBy={dimension.value} />
        </Option>
      ))}
    </Select>
  );
}

export default DimensionDropdown;
